(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2786,5664],{

/***/ "./node_modules/next/dist/build/webpack/loaders/next-client-pages-loader.js?absolutePagePath=private-next-pages%2Fwiki%2F%5Bslug%5D%2Findex.tsx&page=%2Fwiki%2F%5Bslug%5D!":
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wiki/[slug]",
      function () {
        return __webpack_require__("./src/pages/wiki/[slug]/index.tsx");
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ "./src/pages/wiki/[slug]/index.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/react/jsx-runtime.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./node_modules/next/router.js");
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("./node_modules/@chakra-ui/layout/dist/index.esm.js");
/* harmony import */ var _components_SEO_Wiki__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/components/SEO/Wiki.tsx");
/* harmony import */ var _components_Wiki_WikiPage_WikiMarkup__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/components/Wiki/WikiPage/WikiMarkup.tsx");
/* harmony import */ var _services_wikis_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/services/wikis/utils.ts");
/* harmony import */ var _utils_WikiUtils_getWikiImageUrl__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("./src/utils/WikiUtils/getWikiImageUrl.ts");








const Wiki = (param)=>{
    let { wiki  } = param;
    var ref, ref1;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const { slug  } = router.query;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const fetchUserDataAndIncView = async ()=>{
            if (slug) {
                (0,_services_wikis_utils__WEBPACK_IMPORTED_MODULE_5__/* .incrementWikiViewCount */ .N)(slug);
            }
        };
        fetchUserDataAndIncView();
    }, [
        slug
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            wiki && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_SEO_Wiki__WEBPACK_IMPORTED_MODULE_3__/* .WikiHeader */ .r, {
                slug: slug,
                author: ((ref = wiki.author.profile) === null || ref === void 0 ? void 0 : ref.username) || wiki.author.id || "",
                dateModified: wiki.updated,
                datePublished: wiki.created,
                title: "".concat(wiki.title, " - ").concat((ref1 = wiki === null || wiki === void 0 ? void 0 : wiki.categories[0]) === null || ref1 === void 0 ? void 0 : ref1.title),
                description: wiki.summary,
                mainImage: (0,_utils_WikiUtils_getWikiImageUrl__WEBPACK_IMPORTED_MODULE_6__/* .getWikiImageUrl */ .A)(wiki.images)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Box */ .xu, {
                as: "main",
                mt: -2,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Wiki_WikiPage_WikiMarkup__WEBPACK_IMPORTED_MODULE_4__/* .WikiMarkup */ .F, {
                    wiki: wiki
                })
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (Wiki);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5445,4617,3874,3415,2876,5675,2192,7249,8764,5619,4095,6788,6422,4116,4235,2082,1300,6747,8283,3702,7135,8865,9774,2888,179], function() { return __webpack_exec__("./node_modules/next/dist/build/webpack/loaders/next-client-pages-loader.js?absolutePagePath=private-next-pages%2Fwiki%2F%5Bslug%5D%2Findex.tsx&page=%2Fwiki%2F%5Bslug%5D!"); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);